import React, { useEffect, useRef } from "react";
import { Loading } from "../Loading";

export const FetchNext = ({ isFetching, currentPage, handleFetchNext }) => {
  const fetchNext = useRef(null);
  useEffect(() => {
    if (fetchNext.current) {
      const options = {
        root: document,
        rootMargin: "0px",
        threshold: 1,
      };
      const observer = new IntersectionObserver(([entry], observer) => {
        if (entry.isIntersecting && Math.floor(entry.intersectionRatio) === 1) {
          handleFetchNext(observer);
          observer.disconnect();
        }
      }, options);
      observer.observe(fetchNext.current);
    }
  }, [currentPage]);

  return (
    <div id="fetch-next" ref={fetchNext}>
      {isFetching && <Loading />}
    </div>
  );
};
